"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoint = void 0;
var asg_1 = require("@alinta-digital/asg");
var react_1 = require("react");
/** Hook for responsive breakpoints */
var useBreakpoint = function () {
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var breakpoints = (0, react_1.useMemo)(function () { return ({
        isMobile: responsiveSize === 'xs',
        isTablet: responsiveSize === 'sm',
        isSmallDesktop: responsiveSize === 'md',
        isLargeDesktop: responsiveSize === 'lg',
    }); }, [responsiveSize]);
    return breakpoints;
};
exports.useBreakpoint = useBreakpoint;
//# sourceMappingURL=useBreakpoint.js.map